const ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <rect x="3" y="3" width="18" height="18" rx="5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="currentColor"
        d="M14 8.5V6.8c0-.7.5-1.1 1.2-1.1H17V3h-2.4C11.9 3 11 5 11 7.2V8.5H9v3h2V21h3v-9.5H16l.4-3H14z"
      />
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <rect x="2.5" y="6.5" width="19" height="11" rx="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path fill="currentColor" d="M11 9.5v5l4.5-2.5L11 9.5z" />
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="currentColor"
        d="M18.9 7.2h2.1l-4.6 5.3 5.4 7.5h-4.2l-3.3-4.3-3.8 4.3H8.5l4.9-5.6L8.4 7.2h4.3l3 3.9 3.2-3.9zm-1.5 12.1h1.2L9.7 8.4H8.4l9 10.9z"
      />
    </svg>
  ),
  pinterest: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="currentColor"
        d="M12 3a9 9 0 0 0-3.2 17.4c-.1-.8-.2-2 .1-3l1.2-5.1s-.3-.6-.3-1.5c0-1.4.8-2.4 1.9-2.4.9 0 1.3.7 1.3 1.5 0 .9-.6 2.3-.9 3.6-.3 1.1.5 2 1.6 2 1.9 0 3.4-2 3.4-4.9 0-2.6-1.9-4.4-4.6-4.4-3.1 0-4.9 2.3-4.9 4.7 0 .9.4 1.9.8 2.4.1.1.1.2.1.3l-.3 1.2c0 .1-.1.2-.3.1-1.1-.5-1.8-2.1-1.8-3.8 0-3.1 2.3-6 6.7-6 3.5 0 6.2 2.5 6.2 5.9 0 3.5-2.2 6.3-5.3 6.3-1 0-2-.5-2.4-1.2l-.7 2.5c-.2.8-.8 1.8-1.2 2.4A9 9 0 1 0 12 3z"
      />
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path
        fill="currentColor"
        d="M12 2a10 10 0 0 0-8.7 15l-1.3 4.8 4.9-1.3A10 10 0 1 0 12 2zm0 2a8 8 0 0 1 6.8 12.1l.2.3-.3 1.1-1.1.3-.3-.2A8 8 0 1 1 12 4zm-2.4 4.2c-.1 1.5.8 3.6 2.5 5 1.6 1.3 3.7 2 5.1 1.7l.8-.2.4.8.7 1.3-1 .6c-1.5.9-4.5.4-6.9-1.5-2.4-1.9-3.5-4.7-2.8-6.3l.4-.9.8.4.9.1z"
      />
    </svg>
  ),
  website: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path fill="none" stroke="currentColor" strokeWidth="1.8" d="M3 12h18M12 3c2.5 2.8 4 6.4 4 9s-1.5 6.2-4 9c-2.5-2.8-4-6.4-4-9s1.5-6.2 4-9z" />
    </svg>
  ),
  custom: (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden>
      <path fill="currentColor" d="M12 2l2.4 7.4H22l-6 4.6 2.3 7-6.3-4.6L5.7 21l2.3-7-6-4.6h7.6L12 2z" />
    </svg>
  ),
};

export const SOCIAL_PLATFORMS = [
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'twitter', label: 'X / Twitter' },
  { value: 'pinterest', label: 'Pinterest' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'website', label: 'Website' },
  { value: 'custom', label: 'Custom' },
];

export function SocialIcon({ platform = 'website', className = '' }) {
  return (
    <span className={`social-icon ${className}`.trim()} data-platform={platform}>
      {ICONS[platform] || ICONS.website}
    </span>
  );
}

export default SocialIcon;
